// import Loading from 'components/Loading';
import Nixi1Spinner from 'components/Nixi1Spinner'
import React from 'react'

const SignupLoadInit = (props) => {
  return (
    <div className="nfrl loadinit">
      <div className='animated fadeIn'>
        <div className="logo-container">
          <img src={'/img/logo-white.svg'} alt='Logo' />
        </div>
        <div className="nfrl-Loading">
          {/* <Loading></Loading> */}
          <Nixi1Spinner height='25px' width='25px'/>
        </div>
      </div>
    </div>
  )
}

export default SignupLoadInit